export default __webpack_public_path__ + "static/media/background.6e43546f.gif";